<template>
    <div class="CalendarFull">
		<!-- {{ApiData}} -->
        <div class="actionBar d-flex">
			<h3 v-if="this.$GVO.my_profile.adm == 1">Напоминание: фильтр в календаре только для эскро-юристов. hardcore</h3>
			<div class="row d-flex">
				<div class="btn-group btn-group-toggle mr-3" data-toggle="buttons">
					<label
						v-for="(option, index) in tabs.tabStyle"
						:key="option.name"
						class="btn btn-sm btn-primary btn-simple"
						:class="{ active: tabs.activeIndexStyle === index }"
						:id="index"
					>
						<input
							type="radio"
							@click="initTabStyle(index)"
							name="options"
							autocomplete="off"
							:checked="tabs.activeIndexStyle === index"
						/>
						<span class="d-none d-sm-block">{{ option.name }}</span>
						<span class="d-block d-sm-none">
							<i :class="option.icon"></i>
						</span>
					</label>
				</div>
			</div>
		</div>

        <card class="mt-3" 
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
			<ReCalendar
				v-if="tabs.activeIndexStyle==0 || tabs.activeIndexStyle==1 || tabs.activeIndexStyle==2"
				:masTasks="masTasks"
				:strCalendarView="strCalendarView"				
				@prev="onPrevCalendar" @next="onNextCalendar"
			/>
		</card>

    </div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import ReCalendar from "src/our_components/TasksView/ReCalendar.vue";
// import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
import moment from 'moment';

// const today = new Date();
// const y = today.getFullYear();
// const m = today.getMonth();
// const d = today.getDate();
export default {
	name: 'calendar-full',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// ReFilterBtn,
        // ReFilter,
        // ReFormPrinter,
        ReCalendar,
		// ReInputSearchDrop,
	},
	data() {
		return {
            tabs: {
				activeIndexStyle: 0,
				tabStyle: [
					{ name: "День", icon: "d-inline-block tim-ic ic-calendar-day" },
					{ name: "Неделя", icon: "d-inline-block tim-ic ic-calendar-week" },
					{ name: "Месяц", icon: "d-inline-block tim-ic ic-calendar-month" },					
				],
				activeIndexView: 1,
				tabView: [
					{ name: "Все", icon: "d-inline-block tim-ic ic-group" },
					{ name: "Мои", icon: "tim-icons icon-user-run" },
					{ name: "Сотрудник", icon: "tim-icons icon-single-02" }
				]
			},
			bShowFilter: false,
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			masTasks: [],
			refurbushedMasTasks:{},
			bIsLoading: true,
			bIsGeted: false,
			cat_timer: null,
			fullscreenLoading: false,
			iOverdue_p:1,
			iCurrent_p:1,
			iNext_p:1,
			iList_p:1,
			bShowOverdue:true,
			bShowCurrent:true,
			bShowNext:true,
			bShowList:true,
			masCalendarMonth:[],
		};
	},
	computed: {
		strCalendarView: function() {
			if (this.tabs.activeIndexStyle == 0) {
				return "timeGridDay";
			} else if (this.tabs.activeIndexStyle == 1) {
				return "timeGridWeek";
			}
			return "dayGridMonth"; //'dayGridMonth' || 'timeGridDay' || 'timeGridWeek'
		},
		// strCalendarType: function() {
		// 	return "lawCalendar";
		// }
	},
	methods: {
		getTasks(bIsChPage=false,objPageFilterParams={}) {
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			// let c2p = 50;
			// if(typeof this.objGetParams.c2p != 'undefined'){c2p = this.objGetParams.c2p;}
			// if(typeof objPageFilterParams.c2p != 'undefined'){c2p = objPageFilterParams.c2p;}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				for (const key in filter) {
					if(filter[key] == 'true' || filter[key] == true) filter[key] = 1;
					if(filter[key] == 'false' || filter[key] == false) filter[key] = 0;
				}
			}
			if(typeof this.$GVO.my_profile.code != 'undefined' && !this.bIsGeted){
				if(typeof filter.agent_id == 'undefined' || filter.agent_id == '') {
					filter.agent_id = 'my_under';
				}
				//console.log('getTasks',filter);
				this.bIsGeted = true;
				// this.$GVO.ApiCall('GET_TASKS_BY_AGENT',{obj:'services',flt:{...{list:true}, ...filter, ...objPageFilterParams, ...{'c2p':c2p}}})
				this.$GVO.ApiCall('GET_TASK_CALENDAR',{obj:'services',flt:{otdel_id: "14079BF7-C50B-11EA-97CD-005056013FC0", ...filter, ...objPageFilterParams,}}) //otdel_id:otdelid,
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success && objApi.data.length>0){	
							if(bIsChPage){
								for (let i = 0; i < objApi.data.length; i++) {
									if(this.masTasks.find(obj => obj.id === objApi.data[i].id)){

									}else{
										//console.log('getTasks - append');
										this.masTasks.push(objApi.data[i]);
									}
								}
								// if (typeof objPageFilterParams.DEADLINE_LESS != 'undefined' && typeof objPageFilterParams.p != 'undefined') {
								// 	if(objApi.data.length < 50) this.bShowOverdue = false; else this.bShowOverdue = true;
								// 	this.iOverdue_p++;
								// } else if(typeof objPageFilterParams.STARTDATE_LESS != 'undefined' && typeof objPageFilterParams.p != 'undefined'){
								// 	if(objApi.data.length < 50) this.bShowCurrent = false; else this.bShowCurrent = true;
								// 	this.iCurrent_p++;
								// } else if(typeof objPageFilterParams.STARTDATE_MORE != 'undefined' && typeof objPageFilterParams.p != 'undefined'){
								// 	if(objApi.data.length < 50) this.bShowNext = false; else this.bShowNext = true;
								// 	this.iNext_p++;
								// }
							}else{
								this.masTasks = objApi.data;
							}
						}else{
							//console.log('нихуя');
							//this.masTasks.push({"END_DATE":"2022-07-03 15:17:37","id":5816,"act":1,"service_id":794,"BP_TASK_ID":729,"BP_TASK_NAME":"Дата и время + период","STATUS":"Новая","STATUS_END":null,"ON_CONTROL":0,"DEADLINE":"2022-05-05 23:17:37","client_id":465,"InsertTime":"2022-05-05 20:17:37","STARTDATE":"2022-07-03 09:17:37","result_id":null,"dw_file":null,"agent_id":8136,"make_id":0,"ResultDescr":null,"LeadTime":null,"last_task":5815,"BlockType":"none","exe_taskend_id":0,"IN_RUN_TASK":"","OUT_INSUPD_TASK":"","VER":"2022-05-05 20:17:37","noticed":0,"helpdesk_id":0,"helpdesk_name":"","fio":"ыа","agent_name":"Дошин Александр Александрович","BP_NAME":"Проверка ЧЕКЛИСТов","service_agent":"Дошин Александр Александрович","overdue":1,"READONLY":0,"editable":1,"HELPS":[],"ENDS":[{"id":3034,"BP_TASK_ID":729,"ttype":"GOOD","name":"Завершено","tto":",731,","act":1,"BP_ID":62,"end_type":"4","JSON_PARAM":"{\"checklist_api\":{\"checklist_id\":15,\"obj\":\"CHECKLIST_DATETIME_PERIOD\",\"method\":\"GET_CHECKLIST_MODEL\",\"filename\":\"CHECKLIST_DATETIME_PERIOD.php\",\"flt\":{\"id\":\"###TASK_ID###\",\"client_id\":\"###CLIENT_ID###\",\"service_id\":\"###SERVICE_ID###\"}}}","obj_destination":"CHECKLIST_DATETIME_PERIOD","FormConfig":{"success":true,"data":{"success":true,"data":{"rangeTime":{"value":3,"conf_el":{"elementGetParamMap":"startTime|finishTime","element_model":{"startDt":"","endDt":""},"elementType":"input-date-range","label":"Диапазон времени","range_separator":"-","start_placeholder":"Дата с","end_placeholder":"Дата по","type":"datetime","required":true}}}},"config":[{"saveObj":{"apiMethod":"RUN_TASK","apiParam":{"obj":"services","flt":{"taskend_id":-1,"id":-1,"client_id":-1},"uData":[]}},"cancelObj":[],"blockTitle":"","elements":[{"elementGetParamMap":"startTime|finishTime","element_model":{"startDt":"","endDt":""},"elementType":"input-date-range","label":"Диапазон времени","range_separator":"-","start_placeholder":"Дата с","end_placeholder":"Дата по","type":"datetime","required":true,"checklist":{"element_model":true}}]}]}}],"TAGS":[]});
						}
						this.bIsLoading = false;
					})
					.catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			}
		},

		initTabStyle(index) {
			this.tabs.activeIndexStyle = index;
			this.objGetParams['ts'] = this.tabs.activeIndexStyle;
			this.OnFilterApply();
			//this.openFullScreen1();
		},
		initTabView(index) {
			this.tabs.activeIndexView = index;
		},
		setTabStyle(){
			this.objGetParams = this.$GVO.GetAllGet();
			
			if(typeof this.objGetParams['ts'] != 'undefined'){
				this.tabs.activeIndexStyle = parseInt(this.objGetParams['ts']);
				
			}else{
				this.tabs.activeIndexStyle = 0;
			}
		},
		currentFilterConfig() {
			this.$GVO.ApiCall('GET_FILTER_TASKS',{obj:'services'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
						return objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data) {
			//this.objGetParams = data;
			//console.log('OnFilterApply',this.$GVO.unlinkObject(this.objGetParams));
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] === '') delete this.objGetParams[key];
					if(key == 'rb_service') delete this.objGetParams[key];
				}
			}
			//console.log('OnFilterApply',this.$GVO.unlinkObject(this.objGetParams));
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log("OnFilterApply", strItogGetParams, this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit("OnFilterApply", this.objGetParams);
			this.reloadTasksAll();
		},
		// AddTask(){
		// 	this.$router.push({path: '/data/tasks/add'});
		// },
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		/*
		onGetTasks(bIsChPage=false,objPageFilterParams={}){
            this.bIsGeted = false;
            this.getTasks(bIsChPage,objPageFilterParams);

			// if(this.tabs.activeIndexStyle == 2 || this.tabs.activeIndexStyle == 1 ){
			// 	this.bIsGeted = false;
			// 	this.getTasks(bIsChPage,objPageFilterParams);
			// }
			// if(this.tabs.activeIndexStyle == 0){
			// 	this.bIsGeted = false;
			// 	this.groupByDate(bIsChPage,objPageFilterParams);
			// }
			// if(this.tabs.activeIndexStyle == 2){
			// 	this.getKanban();
			// }
		},*/
		// onLoadMore(strType){
		// 	let dateTomorrow = new Date();
		// 	let dtNow = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
		// 	let dNow = moment(new Date()).format('YYYY-MM-DD');
		// 	let dTomorrow = new Date(dateTomorrow.setDate(dateTomorrow.getDate()+1)).toJSON().slice(0, 10);
		// 	if(strType=='overdue'){
		// 		this.onGetTasks(true,{'DEADLINE_LESS':dtNow,'p':this.iOverdue_p});
		// 	} else if(strType=='current'){
		// 		this.onGetTasks(true,{'STARTDATE_LESS':dNow+' 23:59:59','DEADLINE_MORE':dtNow,'p':this.iCurrent_p});
		// 	} else if(strType=='next'){
		// 		this.onGetTasks(true,{'STARTDATE_MORE':dTomorrow+' 00:00:00','DEADLINE_MORE':dtNow,'p':this.iNext_p});
		// 	} else if(strType=='list'){
		// 		this.onGetTasks(true,{'p':this.iList_p});
		// 	}
		// },
		getTasksAll(){
			// if(this.tabs.activeIndexStyle == 0){
			// 	this.onGetTasks();
			// }
			if(this.tabs.activeIndexStyle == 0 || this.tabs.activeIndexStyle == 1 || this.tabs.activeIndexStyle == 2){
				this.bIsGeted = false;
				
				this.masCalendarMonth = [];  // надо придумать какой-то кэшь с данными и в нём передвигаться, и в него же догружать
				this.masCalendarMonth.push(moment().subtract(2, 'months').format('MMYYYY'));
				this.masCalendarMonth.push(moment().subtract(1, 'months').format('MMYYYY'));
				this.masCalendarMonth.push(moment().format('MMYYYY'));

				let dMinus3Month = moment().subtract(2, 'months').format('YYYY-MM-01');
				let objPageFilterParams = {'STARTDATE_MORE':dMinus3Month+' 00:00:00',};

				//console.log(objPageFilterParams);
				
				this.getTasks(false,objPageFilterParams);
			}
		},
		reloadTasksAll(ev){
			//console.log(ev);
			this.iOverdue_p=1;
			this.iCurrent_p=1;
			this.iNext_p=1;
			this.iList_p=1;
			this.masTasks = [];
			this.refurbushedMasTasks = {};
			this.getTasksAll();
			// this.getTasks();
		},
		onPrevCalendar(evtDate){
			//console.log("onPrevCalendar", evtDate);
			let pageMonth = moment(evtDate).subtract(1, 'months').format('MMYYYY');
			//console.log(pageMonth);
			if(this.masCalendarMonth.indexOf(pageMonth) == -1){
				this.masCalendarMonth.push(pageMonth);
				let dMinusMonth = moment(evtDate).subtract(1, 'months').format('YYYY-MM-DD');
				let dMonth = moment(evtDate).format('YYYY-MM-DD');
				let objPageFilterParams = {'STARTDATE_MORE':dMinusMonth+' 00:00:00','STARTDATE_LESS':dMonth+' 00:00:00',};
				//console.log('onPrevCalendar',objPageFilterParams);
				this.bIsGeted = false;
				this.getTasks(true,objPageFilterParams); // надо делать аппенд массива!!! возможно первое true это и делает - проверить
			}
		},
		onNextCalendar(evtDate){
			//console.log("onNextCalendar", evtDate);
			let pageMonth = moment(evtDate).add(1, 'months').format('MMYYYY');
			//console.log(pageMonth);
			if(this.masCalendarMonth.indexOf(pageMonth) == -1){
				//загружаем
			}
		},
		
	
		
	},
	mounted() {
		this.masCalendarMonth = [];		
	},
	created() {
		
		this.cat_timer = setInterval(() => {
			//eventEmitter.$on("reload_tasks", this.reloadTasksAll);
			this.getTasks();
			clearTimeout(this.cat_timer);
		}, 250);
		
		this.objGetParams = this.$GVO.GetAllGet();
		this.setTabStyle();

		//eventEmitter.$on("ResetFilter", this.ResetDopFilter);
		//eventEmitter.$on("reload_tasks", this.reloadTasksAll);
	}
};
</script>
<style scoped>
	.CalendarFull >>> .btn-primary.active {background-color:#01B0E0!important;}
	.CalendarFull .actionBar {
		justify-content: space-between;
		padding-left: 15px;
		flex-wrap: wrap;
	}
	.CalendarFull .actionBar .btn-group {
		height: 32px;
	}
	.CalendarFull .createTaskBtn > button {
		margin-top: 0px;
	}
	.btn:not(.btn-icon) .tim-icons, .navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {
    position: relative;
	top: -1px;
	}
	.filterbutton {
		margin-right: 15px;
	}

	.CalendarFull >>> .bootstrap-switch {width: 200px!important;}

	.CalendarFull >>> .bootstrap-switch .bootstrap-switch-container {width: 100%!important;}

	.CalendarFull >>> .fc-day-grid-event .fc-content {white-space: normal!important;}

	@media (max-width: 398px) {
	}
	@media (max-width: 426px) {
		.CalendarFull .btn-group .btn {
			padding: 4px 15px;
		}
		
	}	

	.white-content .card:not(.card-white) >>>  .fc-dayGrid-view .fc-day-number {color: #5C70A4!important;}
	
</style>
